/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Prep_Intake_BodyInputs */



/**
* | output |
* | --- |
* | "I’ll ask a few short questions in the chat right next to this page to build an agenda tailored to the conversation type you chose. If you have notes from an ..." |
*
* @param {Meeting_Prep_Intake_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_prep_intake_body = /** @type {((inputs?: Meeting_Prep_Intake_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Prep_Intake_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Ik stel je in de chat hiernaast een paar korte vragen om de agenda voor dit gesprek klaar te zetten, op maat van je gekozen gesprekstype. Heb je notities van een vorig gesprek, dan kan je die daar plakken. Daarna vind je hier een eerste opzet die je verder kan aanpassen.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Je vous pose quelques questions rapides dans le chat à côté pour préparer l’ordre du jour de cette conversation, adapté au type de conversation choisi. Si vous avez des notes d’une conversation précédente, vous pouvez les coller là. Vous trouverez ensuite ici une première ébauche que vous pourrez adapter.")
	return /** @type {LocalizedString} */ ("I’ll ask a few short questions in the chat right next to this page to build an agenda tailored to the conversation type you chose. If you have notes from an earlier conversation, you can paste them there. You’ll then find a first draft here, ready for you to adjust.")
});